import useBriefContext from '../../../Hooks/Brief/useBriefContext'
import InputView from '../InputView'
import { ChangeEventHandler, useState } from 'react'
import FormPage from '../../../Components/Form/Page/FormPage'
import { Input } from '../../../Components/Form/Inputs'
import './BudgetInput.less'
import { getCurrencySymbol } from '../../../Utilities/Location'
import isBizBrief from '../../../Logic/Form/Sequences/Biz/isBizBrief'
import { BudgetGuidanceType } from './BudgetGuidance'
import BizBudgetOptions from './Biz/BudgetOptions'
import LFBudgetOptions from './LF/BudgetOptions'

const MAXIMUM_BUDGET = 9000000

const BudgetInput: InputView = ({ path }) => {
  const { brief } = useBriefContext()
  const [budget, setBudget] = useState<number | ''>(brief.budget ?? '')
  const [budgetNotes, setBudgetNotes] = useState<string | ''>(brief.budgetNotes ?? '')

  const [budgetGuidance, setBudgetGuidance] = useState<BudgetGuidanceType>({
    budgetGuidanceBasic: brief.budgetGuidanceBasic,
    budgetGuidanceAverage: brief.budgetGuidanceAverage,
    budgetGuidanceHighEnd: brief.budgetGuidanceHighEnd,
  })
  const currencySymbol = getCurrencySymbol(brief.currency)

  const onChangeBudget: ChangeEventHandler<HTMLInputElement> = ({ target }) => {
    setBudget(target.value && parseInt(target.value, 10))
  }

  const allAttributes = {
    budget: budget === '' ? undefined : Math.min(budget, MAXIMUM_BUDGET),
    budgetNotes: budgetNotes,
    budgetGuidanceBasic: budgetGuidance.budgetGuidanceBasic,
    budgetGuidanceAverage: budgetGuidance.budgetGuidanceAverage,
    budgetGuidanceHighEnd: budgetGuidance.budgetGuidanceHighEnd,
  }

  return (
    <FormPage
      metaTitle='Event budget - HeadBox'
      heading="What's the budget for your event?"
      path={path}
      inputAttributes={allAttributes}
      className='budget-page'>
      <label htmlFor='budget-input' className='visually-hidden'>
        Event budget in {`${currencySymbol} `}
      </label>
      <span className='input-wrapper'>
        <em aria-hidden='true'>{currencySymbol}</em>
        <Input
          id='budget-input'
          type='number'
          value={budget}
          onChange={onChangeBudget}
          fieldName='budget'
          max={MAXIMUM_BUDGET}
          min={1}
          step={1}
          required
        />
      </span>

      <br />

      {isBizBrief(brief) ? (
        <BizBudgetOptions budget={budget} />
      ) : (
        <LFBudgetOptions
          budget={budget}
          setBudgetGuidance={setBudgetGuidance}
          budgetNotes={budgetNotes}
          setBudgetNotes={setBudgetNotes}
        />
      )}
    </FormPage>
  )
}

export default BudgetInput
